import Loadable from '../../components/loadable';

const BulkAddMemberships = Loadable({
  loader: () => import('../../pages/reports/bulk_add_memberships/index'),
});

angular.module('gym').value('BulkAddMemberships', BulkAddMemberships);

const BulkAddMembershipsFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/bulk_add_memberships/bulk_add_memberships_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('BulkAddMembershipsFiltersModal', BulkAddMembershipsFiltersModal);

const BulkAddMembershipsModal = Loadable({
  loader: () => import('../../pages/reports/bulk_add_memberships/bulk_add_memberships_modal'),
  type: 'modal',
});

angular.module('gym').value('BulkAddMembershipsModal', BulkAddMembershipsModal);
